import React, { useState } from 'react';
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { ReactComponent as CameraIcon } from 'bootstrap-icons/icons/camera.svg';
import { useHistory, useParams } from 'react-router-dom';
import { handleResponse } from '../utils/handlers';
import 'react-html5-camera-photo/build/css/index.css';

import styles from './AddConsignmentDocument.module.css';


function AddConsignmentDocument(props) {

    let history = useHistory();
    let { consignmentId } = useParams();

    const [capturing, setCapturing] = useState(false);
    const [image, setImage] = useState(null);
    const [idealFacingMode, setIdealFacingMode] = useState(FACING_MODES.ENVIRONMENT);
    const [description, setDescription] = useState('');
    const [busy, setBusy] = useState(false);

    var capture = (e) => {
        setCapturing(true);
    };

    var handleTakePhoto = (dataUri) => {
        setImage(dataUri);
        setCapturing(false);
    };

    var addDocument = async (e) => {
        if (image === null) {
            alert('No image provided');
            return;
        }

        var blob = await (await fetch(image)).blob();

        var formData = new FormData();
        formData.append('image', blob);
        formData.append('description', description);
        formData.append('consignmentId', consignmentId);

        setBusy(true);
        fetch('api/document/upload', {
            method: 'POST',
            credentials: 'include',
            body: formData
            })
            .then(handleResponse)
            .then(data => {
                setBusy(false);
                history.push(`/consignment/${consignmentId}/documents`);
            })
            .catch(error => {
                setBusy(false);
                alert(error);
                console.log(error);
            });

    }

    function handleCameraError(error) {
        console.log('handleCameraError', error)
    }

    function changeCamera(e) {
        if (idealFacingMode === FACING_MODES.ENVIRONMENT) {
            setIdealFacingMode(FACING_MODES.USER);
        } else {
            setIdealFacingMode(FACING_MODES.ENVIRONMENT);
        }
    }

    return capturing ?
        <React.Fragment>
            <Camera
                isMaxResolution={true}
                idealFacingMode={idealFacingMode}
                imageType={IMAGE_TYPES.JPG}
                isImageMirror={false}
                onCameraError={error => { handleCameraError(error); }}
                onTakePhoto={(dataUri) => handleTakePhoto(dataUri)}
            />
            <Button color="primary" onClick={changeCamera} block>Change Camera</Button>
            <Button color="primary" onClick={e => setCapturing(false)} block>Cancel</Button>
        </React.Fragment>:
        (
            <Form>
                <FormGroup>
                    <Label>Description</Label>
                    <Input type="textarea" value={description} onChange={e => setDescription(e.target.value) }/>
                </FormGroup>
                <Button color="primary" onClick={capture} block><CameraIcon /></Button>
                <div className={styles.imgContainer}>
                    <img className={styles.img} src={image} alt="" />
                </div>
                <Button color="primary" onClick={addDocument} block>Submit</Button>
                <Button color="secondary" onClick={e => history.goBack()} block>Cancel</Button>
                <BusyIndicator isBusy={busy} />
            </Form>
        )
}

export { AddConsignmentDocument };